// extracted by mini-css-extract-plugin
export var content = "_r1-1";
export var noScroll = "_r1-3";
export var paper = "_r1-0";
export var scrollable = "_r1-2";